import { useSuspenseQuery } from '@tanstack/react-query';

import { ApiRoutes, QueryKeyEnum, TimeEnum } from '@lib/enums';
import { useHttp } from '@lib/http';

import type { TCallScriptStep } from '@components/callScript/types';
import type { UseSuspenseQueryResult } from '@tanstack/react-query';

export type TCallScriptResponse = {
  scriptKey: string;
  title?: string;
  steps: TCallScriptStep[];
};
export function useSuspenseQueryCallScript(
  scriptKey: string,
  contractNumber: Maybe<string>,
): UseSuspenseQueryResult<Nullable<TCallScriptResponse>> {
  const { http } = useHttp();

  return useSuspenseQuery({
    queryKey: [QueryKeyEnum.CallScript, scriptKey, contractNumber],
    queryFn: () =>
      http
        .get(ApiRoutes.Contacts.CallScript, { scriptKey, contractNumber })
        .sendx<TCallScriptResponse>({ allowNoContent: true }),
    staleTime: TimeEnum.FiveMinutes,
  });
}
